import { render, staticRenderFns } from "./OrdersEdit.vue?vue&type=template&id=dc28a5c6&scoped=true&"
import script from "./OrdersEdit.vue?vue&type=script&lang=js&"
export * from "./OrdersEdit.vue?vue&type=script&lang=js&"
import style0 from "./OrdersEdit.vue?vue&type=style&index=0&id=dc28a5c6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc28a5c6",
  null
  
)

export default component.exports